// extracted by mini-css-extract-plugin
export default {"pageMain":"WorkFromHome_pageMain__EXhgi"};